/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiPlayersGet200Response } from '../models';
/**
 * PlayersApi - axios parameter creator
 * @export
 */
export const PlayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiPlayersIdsGet', 'ids', ids)
            const localVarPath = `/api/players/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlayersApi - functional programming interface
 * @export
 */
export const PlayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayersApi.apiPlayersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get favorites players by ids
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayersIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPlayersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlayersIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlayersApi.apiPlayersIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlayersApi - factory interface
 * @export
 */
export const PlayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlayersApiFp(configuration)
    return {
        /**
         * Get all players
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayersGet200Response> {
            return localVarFp.apiPlayersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get favorites players by ids
         * @param {PlayersApiApiPlayersIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayersIdsGet(requestParameters: PlayersApiApiPlayersIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiPlayersGet200Response> {
            return localVarFp.apiPlayersIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiPlayersIdsGet operation in PlayersApi.
 * @export
 * @interface PlayersApiApiPlayersIdsGetRequest
 */
export interface PlayersApiApiPlayersIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayersApiApiPlayersIdsGet
     */
    readonly ids: string
}

/**
 * PlayersApi - object-oriented interface
 * @export
 * @class PlayersApi
 * @extends {BaseAPI}
 */
export class PlayersApi extends BaseAPI {
    /**
     * Get all players
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public apiPlayersGet(options?: RawAxiosRequestConfig) {
        return PlayersApiFp(this.configuration).apiPlayersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get favorites players by ids
     * @param {PlayersApiApiPlayersIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public apiPlayersIdsGet(requestParameters: PlayersApiApiPlayersIdsGetRequest, options?: RawAxiosRequestConfig) {
        return PlayersApiFp(this.configuration).apiPlayersIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
}

